import { Badge } from "@/components/ui/badge";
export default function TheHeartOfEnfield() {
  return <section data-section-id="223658" id="the-heart-of-enfield" className="dark bg-background text-foreground relative py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-10" style={{
      backgroundImage: "linear-gradient(to bottom, var(--color-secondary) 1px, transparent 1px)",
      backgroundSize: "100% 40px"
    }} aria-hidden="true" />

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-1/2 bg-secondary/20 blur-[120px] rounded-lg pointer-events-none" aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10 flex flex-col items-center text-center max-w-4xl">
        <Badge variant="destructive" className="mb-10 text-sm tracking-[0.2em] uppercase px-4 py-1.5 font-default bg-primary text-primary-foreground">
          Our Heritage
        </Badge>

        {}
        <div className="border-l-2 border-r-2 border-secondary/30 px-6 md:px-16 py-6 flex flex-col gap-8">
          <h2 className="font-default text-4xl md:text-6xl lg:text-7xl font-medium tracking-tight text-foreground drop-shadow-sm">
            The Heart of Enfield
          </h2>

          <p className="font-serif text-[22px] font-light leading-relaxed text-muted-foreground max-w-2xl mx-auto">
            M&M Café & Market began with a simple vision: to bring the authentic flavors of a European morning to our local neighborhood. From the first pull of espresso to the arrival of fresh focaccia, every detail is a labor of love.
          </p>
          
          <p className="font-serif text-[22px] font-light leading-relaxed text-muted-foreground max-w-2xl mx-auto">
            We are more than just a café; we are a gathering place where the aroma of artisanal matcha meets the curated shelves of our specialty market. Join us in celebrating the simple joys of quality ingredients and warm community.
          </p>
        </div>
      </div>
    </section>;
}